import script from "./archived-only-checkbox.vue?vue&type=script&setup=true&lang=js"
export * from "./archived-only-checkbox.vue?vue&type=script&setup=true&lang=js"

import "./archived-only-checkbox.vue?vue&type=style&index=0&id=b3001be4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3001be4"]])

export default __exports__